import React, { useState } from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Box, Button, Text } from '@betterment/samba-react';
import { HR } from '@betterment/style-closet-react';

import BreakdownByYearContributions from './breakdownByYearIraContributions';

import { TextShimmerLoader } from '../../Shared/components/ShimmerLoaders';
import { useIraContributionsAllTimeQuery } from '../hooks';

const AllTimeContributions: React.FC<React.PropsWithChildren> = () => {
  const [hasViewDetailsModalOpen, setHasViewDetailsModalOpen] = useState(false);
  const { isLoading, iraContributionsAllTime } = useIraContributionsAllTimeQuery();

  return (
    <Box css={{ mt: 'space.200' }}>
      {isLoading && <TextShimmerLoader numLines={2} />}
      {!isLoading && iraContributionsAllTime && (
        <>
          <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text>Total contributions</Text>
            <Text>{formatMoney(iraContributionsAllTime.amount)}</Text>
          </Box>
          <HR my="6" />
          {iraContributionsAllTime.lineItems.map(lineItem => {
            return (
              <Box key={lineItem.id}>
                <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Text variant="text50" color="text.weak">
                    {lineItem.name}
                  </Text>
                  <Text variant="text50" color="text.weak">
                    {formatMoney(lineItem.amount)}
                  </Text>
                </Box>
                <HR my="6" />
              </Box>
            );
          })}
          <Box css={{ marginTop: 'space.200' }}>
            <Button onClick={() => setHasViewDetailsModalOpen(true)} variant="textPrimary">
              See deposit breakdown by year
            </Button>
          </Box>
          {hasViewDetailsModalOpen && (
            <BreakdownByYearContributions closeHandler={() => setHasViewDetailsModalOpen(false)} />
          )}
        </>
      )}
    </Box>
  );
};

export default AllTimeContributions;
